import React, { useState } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Identity } from '@wajeez-web/core/api-base';
import { TextInput, SwitchInput } from '@wajeez-web/components/ui';
const CreateNewAdminModal: React.FC<
  CommonModalProps<Identity.CreateAdminInput>
> = ({ isOpen, onClose, onSubmit }) => {
  const [adminData, setAdminData] = useState<Identity.CreateAdminInput>({
    name: '',
    password: '',
    email: '',
    isVerified: true,
  });

  const onAdminDataChange = (name: string, val: string | boolean) => {
    setAdminData({ ...adminData, [name]: val });
  };
  return (
    <Modal
      onSubmit={() => onSubmit && onSubmit(adminData)}
      open={isOpen}
      onClose={onClose}
      title="Create New Admin"
      withScroll={true}
    >
      <div className=" space-y-10">
        <div className={`grid grid-cols-${2} gap-3 `}>
          <div className={`md:col-span-${2} col-span-${2}`}>
            <TextInput
              value={adminData.name}
              label={'Name'}
              name={'name'}
              onChange={onAdminDataChange}
            />
          </div>
          <div className={`md:col-span-${1} col-span-${2}`}>
            <TextInput
              value={adminData.email}
              label={'Email'}
              name={'email'}
              onChange={onAdminDataChange}
            />
          </div>
          <div className={`md:col-span-${1} col-span-${2}`}>
            <TextInput
              value={adminData.password}
              label={'Password'}
              name={'password'}
              onChange={onAdminDataChange}
            />
          </div>

          <div className={`md:col-span-${1} col-span-${2}`}>
            <SwitchInput
              value={adminData.isVerified}
              label={'Is Verified'}
              name={'isVerified'}
              onChange={onAdminDataChange}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateNewAdminModal;
